// import {ASSETS_ROOT} from './../../../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');

	const sphere = geo.createNode('sphere');
	const box = geo.createNode('box');
	const torus = geo.createNode('torus');
	const transform1 = geo.createNode('transform');
	const transform2 = geo.createNode('transform');
	const merge1 = geo.createNode('merge');
	const merge2 = geo.createNode('merge');

	transform1.setInput(0, sphere);
	transform2.setInput(0, box);

	merge1.setInput(0, transform1);
	merge1.setInput(1, transform2);
	merge1.setCompactMode(true);
	box.p.center.x.set(3);

	merge2.setInput(0, merge1);
	merge2.setInput(1, torus);
	merge2.flags.display.set(true);

	torus.p.radius.set(`bbox('../${merge1.name()}').max.x`);
	torus.p.radiusTube.set(0.15);
	torus.p.segmentsRadial.set(5);
	torus.p.segmentsTube.set(60);
	torus.p.direction.set([0, 0, 1]);

	torus.uiData.setComment(`The torus's radius is linked to the bounding box of the sphere and the box.

Try and move either the sphere or the box to see how the torus scales up and down.`);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	// EXPORT
	// const nodes = [torus];
	// const htmlNodes = {box};
	// const camera = perspectiveCamera1;
	// return {scene, camera, nodes, htmlNodes};
	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [torus],
		autoLayout: true,
	};
}

// export const expressionBbox = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_CATEGORY}/${ExamplePrefix.USING_EXPRESSIONS}/bbox`,
// 		createData,
// 		relatedExpressions: [ExpressionType.bbox],
// 	}),
// ];
